const initialState = {
    token: undefined,   
    playlists: undefined 
  }
  
export function SpotifyData (state = initialState, action) {

    switch(action.type){                
        case 'SET_TOKEN':
            return{
                ...state,
                token: action.token 
            }
        case 'SET_PLAYLISTS':
            return{
                ...state,
                token: action.playlists
            }
        default:            
            return state
    }
}